import angular from 'angular';

import RestangularStatusImport from './RestangularStatus';
import AuthenticationImport from './Authentication';

const securityModule = angular.module('components.security', []);

securityModule.factory('RestangularStatus', RestangularStatusImport);
securityModule.factory('Authentication', AuthenticationImport);

export default securityModule.name;
